import { createContext, useState } from "react";
import { SignupDataType } from "../../types/auth";

type SignupContextType = {
  userData: SignupDataType;
  updateSignupData: (newData: Partial<SignupDataType>) => void;
};

const defaultValue: SignupContextType = {
  userData: {
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    birthdate: undefined,
    gender: "M",
  },
  updateSignupData: (newData: Partial<SignupDataType>) => {},
};
export const SignupContext = createContext(defaultValue);

const SignupContextProvider = (props: { children: React.ReactNode }) => {
  const [userData, setUserData] = useState<SignupDataType>(
    defaultValue.userData
  );

  const updateSignupData = (newData: Partial<SignupDataType>) => {
    setUserData((prev) => ({ ...prev, ...newData }));
  };

  return (
    <SignupContext.Provider
      value={{
        userData,
        updateSignupData,
      }}
    >
      {props.children}
    </SignupContext.Provider>
  );
};

export default SignupContextProvider;
